import { ExtractGetterProps } from 'shared-definitions/util-types'
import PageContainer from 'shared-components/service/PageContainer'
import { getNewsPageProps } from 'props-getters/newsletters'
import NewslettersCatalogTemplate from 'shared-components/templates/NewslettersCatalogTemplate'
import Layout from 'components/Layout'
import { useNewsletterSubscribe } from 'hooks/use-newsletter-subscribe'
import { DSNewslettersCatalog } from 'shared-definitions/types'

const IntermediateComponent: React.VFC<{ page: DSNewslettersCatalog }> = props => {
  const submitProps = useNewsletterSubscribe()
  return (
    <NewslettersCatalogTemplate company="android authority" page={props.page} {...submitProps} />
  )
}

const NewsletterCatalogPage: React.VFC<ExtractGetterProps<typeof getNewsPageProps>> = ({
  page,
  common,
  ts,
  preview,
}) => (
  <PageContainer layoutProps={{}} layout={Layout} props={{ page, common, ts, preview }}>
    <IntermediateComponent page={page} />
  </PageContainer>
)

export const getStaticProps = getNewsPageProps()

export default NewsletterCatalogPage
